import React, { useState, useEffect } from 'react';
import { ThemeProvider, StyledEngineProvider, createTheme } from '@mui/material/styles';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import {
  getParam, setKey, setSessionKey, setLanguage,
} from 'utils';
import { Helmet } from 'react-helmet';
// import ReactGA from 'react-ga';
import Routes from './routes';
import Store from './redux/store';
import {
  inject, getConfig, staticPath, setConfig,
} from './utils/config';

const theme = createTheme();

const App = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isTokenLoaded, setIsTokenLoaded] = useState(!getParam('dcd'));
  const [configsState, setConfigsState] = useState(getConfig() || {});

  useEffect(() => {
    window.onmessage = (e) => {
      const {
        event, token, user, brandId = '',
      } = e.data;

      if (event === 'dcdInfos') {
        setSessionKey('jwtToken', token);
        setSessionKey('userMail', user.email);
        setSessionKey('userCurrency', user.currency);
        setSessionKey('userCurrency', user.currency);
        setSessionKey('brandId', brandId);
        setIsTokenLoaded(true);
      }
    };

    if (getParam('lang')) setLanguage(getParam('lang'));
    if (getParam('token')) setSessionKey('jwtToken', getParam('token'));
    if (getParam('dcd')) {
      if (getParam('isReseller') === 'true') {
        setKey('isReseller', true);
        if (getParam('contractnumber')) setKey('selectedContractId', getParam('contractnumber'));
      } else {
        setKey('isReseller', false);
      }

      setKey('isAccessByDCD', true);
      document.body.addEventListener('mousemove', () => {
        window.top.postMessage('mouseMovefromMdcd', '*');
      });
    }

    inject().then(() => {
      if (getParam('config')) setConfig(getParam('config'));
      // eslint-disable-next-line
      setConfigsState(getConfig() || {});

      setIsLoaded(true);
      console.log('%cDATA CENTER DESIGNER 📱', window.atob('Zm9udC1zaXplOjYwcHg7Y29sb3I6I0ZGMDAzRDtwYWRkaW5nOiAxMDBweCAxMHB4IDAgMTBweA=='));
      // eslint-disable-next-line
      console.log('%cPlease don\'t paste or execute any script here', window.atob('Zm9udC1zaXplOjIwcHg7Y29sb3I6I0ZGMDAzRDtwYWRkaW5nOiAwIDEwcHggMTAwcHggMTBweA=='));
    });
  }, []);

  useEffect(() => {
    if (isLoaded) {
      import('themes').then((e) => e);

      // ReactGA.initialize(configsState.gaTrackingId, {
      //   debug: !configsState.gaIsTracking,
      //   testMode: !configsState.gaIsTracking,
      // });

      // ReactGA.pageview(window.location.pathname);
    }
  // eslint-disable-next-line
  }, [isLoaded, configsState]);

  return isLoaded && isTokenLoaded ? (
    <Provider store={Store}>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <Routes />
          {configsState.theme === 'sds' ? (
            <Helmet>
              <link rel="shortcut icon" href={`${staticPath}/favicon-sds.ico`} />
              <title>Samsung Cloud Public DCD</title>
            </Helmet>
          ) : configsState.theme === 'ionos' ? (
            <Helmet>
              <link rel="shortcut icon" href={`${staticPath}/favicon-ionos.ico`} />
              <title>IONOS DCD</title>
            </Helmet>
          ) : configsState.theme === 'itzbund' ? (
            <Helmet>
              <link rel="shortcut icon" href={`${staticPath}/favicon-ionos.ico`} />
              <title>ITZBund DCD</title>
            </Helmet>
          ) : configsState.theme === 'bechtle' ? (
            <Helmet>
              <link rel="shortcut icon" href={`${staticPath}/favicon-bechtle.ico`} />
              <title>Bechtle Cloud Public DCD</title>
            </Helmet>
          ) : (
            <Helmet>
              <link rel="shortcut icon" href={`${staticPath}/favicon-base.ico`} />
              <title>Base Brand DCD</title>
            </Helmet>
          )}
        </ThemeProvider>
      </StyledEngineProvider>
    </Provider>
  ) : (
    <></>
  );
};

ReactDOM.render(<App />, document.getElementById('root'));
